import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { injectConfig, configShape } from '@client/hoc/config';
import { getClientDeviceHeight, getClientDeviceWidth } from '@client/redux/modules/clientDevice/selectors';
import { getUpcoming } from '@client/redux/modules/mylounge-legacy/selectors';

import SectionTitle from '@client/components/shared/sectionTitle';
import NotificationPermissionDialog from '@client/components/mylounge/NotificationPermission/NotificationPermissionWrapper';
import NotificationReenableDialog from '@client/components/mylounge/NotificationReenableDialog';
import Grid from '@client/components/mylounge/campaigns/Grid';
import MobileCampaigns from '@client/components/mylounge/campaigns/mobileCampaigns/MobileCampaigns';

import { isXsScreen, isMdScreen } from '@client/helpers/screens';

class UpcomingSection extends PureComponent {
    static propTypes = {
        upcoming: PropTypes.object.isRequired,
        location: PropTypes.object,
        params: PropTypes.object,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        hasTitle: PropTypes.bool,
        config: configShape
    }

    render() {
        const {
            upcoming,
            width,
            height,
            params,
            location,
            config,
            hasTitle
        } = this.props;

        if (!upcoming || !upcoming.campaigns || !upcoming.grid) {
            return null;
        }

        const xsScreen = isXsScreen(width);
        const notificationEnabled = config.isEnabled('pushNotification');
        const containerWidth = isMdScreen(width) ? width : (width * 0.8);

        return (
            <div id="upcoming-campaigns">
                { notificationEnabled &&
                    <Fragment>
                        <NotificationPermissionDialog />
                        <NotificationReenableDialog />
                    </Fragment>
                }
                { hasTitle &&
                    <SectionTitle message="campaigns.upcomingTitle" />
                }

                {xsScreen ?
                    <MobileCampaigns
                        id="upcoming"
                        width={containerWidth}
                        height={height}
                        params={params}
                        myloungeData={upcoming}
                        location={location}
                    />
                    :
                    <Grid
                        id="upcoming"
                        width={containerWidth}
                        params={params}
                        campaigns={upcoming}
                        location={location}
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    height: getClientDeviceHeight(state),
    width: getClientDeviceWidth(state),
    upcoming: getUpcoming(state)
});

export default compose(
    connect(mapStateToProps),
    injectConfig
)(UpcomingSection);
